import { render, staticRenderFns } from "./radish-pro-score.vue?vue&type=template&id=f1fc58d6&scoped=true"
import script from "./radish-pro-score.vue?vue&type=script&lang=js"
export * from "./radish-pro-score.vue?vue&type=script&lang=js"
import style0 from "./radish-pro-score.vue?vue&type=style&index=0&id=f1fc58d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fc58d6",
  null
  
)

export default component.exports